import { X } from 'lucide-react'
import { Button } from '../common/Button'
import styles from './SelectionActionBar.module.css'

export function SelectionActionBar({
  count = 0,
  noun = 'item',
  scope,
  note,
  onClear,
  clearLabel = 'Clear selection',
  pending = false,
  sticky = false,
  ariaLabel = 'Selection actions',
  displayCountLabel,
  announce = true,
  children,
  className = '',
}) {
  const countLabel = `${count} ${count === 1 ? noun : `${noun}s`} selected`
  const visibleCountLabel = displayCountLabel || `${count} selected`

  return (
    <>
      {announce ? <span className={styles.announcement} aria-live="polite" aria-atomic="true">{countLabel}</span> : null}
      {count ? (
        <section
          className={[styles.root, sticky ? styles.sticky : '', className].filter(Boolean).join(' ')}
          aria-label={ariaLabel}
        >
          <div className={styles.meta}>
            <strong>{visibleCountLabel}</strong>
            {scope ? <span className={styles.scope}>{scope}</span> : null}
            {note ? <span className={styles.note}>{note}</span> : null}
          </div>
          <div className={styles.actions}>
            {onClear ? (
              <Button variant="ghost" size="compact" onClick={onClear} disabled={pending}>
                <X size={14} aria-hidden="true" />
                {clearLabel}
              </Button>
            ) : null}
            {children}
          </div>
        </section>
      ) : null}
    </>
  )
}

export default SelectionActionBar
